<template>
  <CCol>
    <!-- <CRow>
      <CCol sm="12" class="text-white">
        <h1 class="mb-5">{{ $t('auth.businessProfile.header1.type-account') }}</h1>
        <p class="font-xl text-gray-700">
          {{ $t('auth.businessProfile.text.wheter-you') }}
        </p>
        <p class="font-xl text-gray-700">
          {{ $t('auth.businessProfile.text.you-will') }}
        </p>
      </CCol>
    </CRow>
    <Steps :steps="3" :stepActive="2" :progress="80" /> -->
  </CCol>
</template>

<script>
import Steps from '@/views/auth/components/aside/Steps.vue'

export default {
  name: 'AsideCompany',
  components: {
    Steps,
  },
}
</script>

<style></style>
